export enum WMTDisconnectReason {
  BadFormat = 'BF',
  InvalidSubscriptionDestination = 'ID',
  UnknownOrigin = 'UO',
  InvalidMessageType = 'MT',
  TokenRequired = 'TR',
  UserChangeNotAllowed = 'UC',
  BadSignature = 'BS',
  InvalidToken = 'IT',
  InvalidSessionId = 'IS',
  VelocityControl = 'VC',
  MaxSubscriptionExceeded = 'MS'
}
